export default __webpack_public_path__ + "static/grid-9453555da970e1b7ce5b4c1d7130e2f6.png";